<section>
  <header>
    <h1 auto="envisioning-title">Envisioning Phase</h1>
  </header>
  <div class="information-container">
    <div>
      <p><strong>Synthesize Results</strong></p>
      <p>
        The purpose of Synthesize Results is to ensure all guiding principles align with the institution’s new priority statements. If the institution’s vision, mission, and set of beliefs need to be revised because of misalignment with the priorities, take the opportunity to update the language and check for the accuracy of each statement.
      </p>
      <p>
        Use your identified future trends and impacted stakeholders to connect your institution’s future priority statements. Remember to think about the connections or impacts the future can have on reality and vice versa. Once the connections are established, think about the big idea or strategic theme for each priority statement.
      </p>
      <p>
        You may include your existing priority statements, edit to rewrite these statements, or delete priority statements that no longer align with your institution’s guiding principles. These statements may be reordered to best clarify your path to envisioning the future. Please select <strong>Next</strong> to continue.
      </p>
    </div>
  </div>
  <div class="explanation-margin">
    <div class="download-guide-container">
      <img class="book-icon pointer" src="assets/images/download-guide-icon.svg" alt="book-icon" (click)="openGuide()">
      <span class="download-tagline pointer" (click)="openGuide()">Download the guide</span> to learn more about <strong>Synthesize Results</strong>.
    </div>
  </div>


  <ul class="styleless froala-list">
    <li>
      <app-rich-content editorTitle="1. Institution's Vision:"
                        placeholderText="Enter Vision here"
                        [content]="purpose"
                        [maxContentLength]="MAX_PURPOSE_LENGTH"
                        [isReadOnly]="isEditItemDisabled"
                        (contentUpdate)="updatePurpose.emit($event)">
      </app-rich-content>
    </li>
    <li>
      <app-rich-content editorTitle="2. Institution's Mission:"
                        placeholderText="Enter Mission here"
                        [content]="mission"
                        [maxContentLength]="MAX_MISSION_LENGTH"
                        [isReadOnly]="isEditItemDisabled"
                        (contentUpdate)="updateMission.emit($event)">
      </app-rich-content>
    </li>
    <li>
      <app-rich-content editorTitle="3. Institution's Beliefs:"
                        placeholderText="Enter Beliefs here"
                        [content]="beliefs"
                        [maxContentLength]="MAX_BELIEFS_LENGTH"
                        [isReadOnly]="isEditItemDisabled"
                        (contentUpdate)="updateBeliefs.emit($event)">
      </app-rich-content>
    </li>
  </ul>
  <div class="add-priority-row">
    <button auto="add-priority-btn" class="btn btn-primary" [disabled]="isAddPrioritiesDisabled"
            (click)="onClickAddPriorities()">
      Add New
    </button>
  </div>
  <div [ngClass]="{'priority-table-container': true,
                   'reordering': reorderInProgress && !reorderFailed,
                   'reordering-failed': reorderFailed}">
    <p-table auto="priorities-table"
             [value]="priorities"
             styleClass="priorities-table rounded-zebra-table"
             (onRowReorder)="onRowReorder($event)">
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="prioritiesColWidth" class="ui-table-empty-message">
            No Priorities Added
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="color-column"></th>
          <th>Priority Statement</th>
          <th>Strategic Theme</th>
          <th class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-priority let-index="rowIndex">
        <tr [pReorderableRow]="index" class="reorder-priority-row">
          <td class="color-column reorder-priority-wrapper reorder-priority-hover" pReorderableRowHandle>
            <span #cell>{{getCellColor(cell, priority)}}</span>
            <i class="reorder-priority-handle" pReorderableRowHandle></i>
          </td>
          <td class="reorder-priority-hover" pReorderableRowHandle>
            <span pReorderableRowHandle>{{priority.description}}</span>
          </td>
          <td class="reorder-priority-hover" pReorderableRowHandle>
            <span pReorderableRowHandle>{{priority.title}}</span>
          </td>
          <td class="actions-column reorder-priority-nohover" *ngIf=
            "!isEditItemDisabled && !isDeleteItemDisabled">
            <button auto="edit-priority-table" class="fa fa-pencil pointer" pTooltip="Edit Item" tooltipStyleClass="strategies-tooltip"
                    *ngIf="!isEditItemDisabled" (click)="onClickEditPriority(priority)">
            </button>
            <button auto="delete-priority-table" [attr.priority]="priority" class="fa fa-trash pointer" pTooltip="Delete Item"
                    tooltipStyleClass="strategies-tooltip"
                    *ngIf="!isDeleteItemDisabled" (click)="onClickDeleteItem(priority)">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div *ngIf="reorderInProgress" class="reordering-msg-container">
      <div [ngClass]="{ 'reordering-center-container': true,
                        'reordering-failed': reorderFailed }">
        <div class="reordering-spinner">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <div class="reordering-message">Please Wait...</div>
        <div *ngIf="reorderFailed" class="reordering-message refresh-pending">Another user wth permissions to this plan has changed this information.</div>
      </div>
    </div>
  </div>
</section>

<p-sidebar #prioritySidebar
           [(visible)]="isPriorityActive"
           appendTo="body"
           position="right"
           styleClass="priorities-sidebar"
           (onShow)="priority.onShowSidebar(prioritySidebar)"
           (onHide)="priority.onHideSidebar()">
  <app-priority #priority
                (create)="onPriorityCreate($event)"
                (createError)="onItemError($event)"
                (edit)="onPriorityEdit($event)"
                (editError)="onItemError($event)"
                (cancel)="isPriorityActive = false">
  </app-priority>
</p-sidebar>

<p-dialog #confirmDeleteDialog styleClass="strategies-confirm-dialog" [modal]="true" [closable]="false" appendTo="body">
  <p-header>
    <img src="assets/images/exclamation.svg" alt="Alert">
    <span class="dialog-title">Delete Priority</span>
  </p-header>
  <div>Deleting this will also impact any associated content.</div>
  <div><strong>Do you want to continue?</strong></div>
  <p-footer>
    <button auto="envision-step1-cancel-btn" class="btn btn-alt" type="button" pButton label="Cancel"
            (click)="confirmDeleteDialog.visible = false"></button>
    <button auto="envision-step1-delete-btn" class="btn" type="button" pButton label="Delete"
            (click)="onConfirmDeleteDialogAccept()"></button>
  </p-footer>
</p-dialog>
